module.exports = __webpack_public_path__ + "img/Jessica_Knox.515c3a41.jpg";